import { countWorkingTreeChangedFilesForRepo } from '../changes/count-working-tree-changed-files.js';
import { commitsAheadOfRemoteTracking } from '../commits/remote-tracking/index.js';
import { cliSimpleGit } from '../cli-simple-git.js';
import { forEachWithGitYield, runGitTask } from '../git-runtime.js';

export async function countRepoUncommittedFiles(repoDir: string): Promise<number> {
  return countWorkingTreeChangedFilesForRepo(repoDir);
}

export async function getRepoWorkingTreeStatus(repoDir: string): Promise<{
  hasUncommittedChanges: boolean;
  hasUnpushedCommits: boolean;
  uncommittedFileCount: number;
}> {
  return runGitTask(async () => {
    const uncommittedFileCount = await countWorkingTreeChangedFilesForRepo(repoDir);
    const hasUncommittedChanges = uncommittedFileCount > 0;
    const ahead = await commitsAheadOfRemoteTracking(repoDir);
    return { hasUncommittedChanges, hasUnpushedCommits: ahead > 0, uncommittedFileCount };
  });
}

export async function aggregateSessionPathsWorkingTreeStatus(paths: string[]): Promise<{
  hasUncommittedChanges: boolean;
  hasUnpushedCommits: boolean;
  uncommittedFileCount: number;
}> {
  let hasUncommittedChanges = false;
  let hasUnpushedCommits = false;
  let uncommittedFileCount = 0;
  await forEachWithGitYield(paths, async (p) => {
    const s = await getRepoWorkingTreeStatus(p);
    uncommittedFileCount += s.uncommittedFileCount;
    if (s.hasUncommittedChanges) hasUncommittedChanges = true;
    if (s.hasUnpushedCommits) hasUnpushedCommits = true;
  });
  return { hasUncommittedChanges, hasUnpushedCommits, uncommittedFileCount };
}

export async function pushAheadOfUpstreamForPaths(paths: string[]): Promise<void> {
  await forEachWithGitYield(paths, async (p) => {
    const g = cliSimpleGit(p);
    const ahead = await commitsAheadOfRemoteTracking(p);
    if (ahead <= 0) return;
    await g.push();
  });
}
